import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';


let isViewFullListHotbox = false;
/**
 * Define constant variables
 */
export const METRIC_COUNTING_RANGE = 4;
export const METRIC_COUNTING_SURVEY_YES_NO = 5;
export const METRIC_COUNTING_SURVEY_SCALE = 6;
export const METRIC_PERCENTAGE = 3;

export const HEALTH_GOOD = 1;
export const HEALTH_OK = 2;
export const HEALTH_RISK = 3;

export const PORIORITY_P1 = 1;
export const PORIORITY_P2 = 2;
export const PORIORITY_P3 = 3;
export const PORIORITY_P4 = 4;
export const PORIORITY_P5 = 5;

export const PACE_SLOW = 1;
export const PACE_STEADY = 2;
export const PACE_FAST = 3;

/**
*  This method is used to get an image path.
*/
const IconPathComp = function (id) {
  const imgPath = {
    doing: 'images/icons/doing_blue.png',
    red: 'images/rbr/red@2x.png',
    amber: 'images/rbr/amber@2x.png',
    green: 'images/Priorities/green.png',
    late: 'images/rbr/late@2x.png',
    add: 'images/icons/dropdowns/add.png',
    close: 'images/icons/close_x.png',
    close_image: 'images/icons/del_gray.png',
    goal: 'images/rbr/goals@2x.png',
    metric: 'images/rbr/metrics@2x.png',
    red_1on1_epa: 'images/rbr/member@2x.png',
    ai: 'images/rbr/action_items@2x.png',
    today_empty: 'images/rbr/today_empty.png',
    metrics_empty: 'images/rbr/metrics_empty.png',
    goals_empty: 'images/rbr/goals_empty.png',
    ws_empty: 'images/rbr/ws_empty.png',
    hotbox_empty: 'images/rbr/hotbox_empty.png',
    blue_additem: 'images/rbr/blue_additem.png',
    ws_grey: 'images/rbr/ws@2x.png',
    loadinggif: 'images/icons/loading.gif',
    priority_highest: 'images/Priorities/top_priority.png',
    priority_high: 'images/Priorities/medium.png',
    removefromtray_img: 'images/icons/dropdowns/close.png',
    edit_img: 'images/icons/dropdowns/edit.png',
    edit_image: 'images/icons/edit_gray_s.png',
    delete_img: '/images/icons/dropdowns/delete.png',
    closegoal_img: '/images/icons/dropdowns/closegoal.png',
    copy_img: '/images/icons/dropdowns/copy.png',
    ping_img: '/images/icons/dropdowns/ping.png',
    badge_img: '/images/icons/dropdowns/badge.png',
    addtomeet_img: '/images/icons/dropdowns/addtoteammeeting.png',
    addto1on1_img: '/images/icons/dropdowns/addto1on1.png',
    print_img: '/images/icons/dropdowns/print.png',
    personalize_img: '/images/icons/menu/settings_menu.png',
    share_img: '/images/share-img-icon.png',
    dummyOwnerImg: '/images/profile/LetterImages/Letters_A.png',
    addAiPlus: '/images/icons/board/add_grey.png',
    addAttach: '/images/icons/add_attachement.png',
    full_det_img: '/images/icons/board/full_details.png',
    publish_img: '/images/icons/publish.png',
    publish_img_board: '/images/icons/publish_board.png',
    permissions_img: 'images/icons/dropdowns/permissions.png',
    move_img: 'images/icons/dropdowns/move.png',
    close_img: 'images/icons/dropdowns/close.png',
    rbr_add_img: 'images/icons/RBR_kebab.png',
    integration_img: 'images/icons/dropdowns/pushtointegration.png',
    reopen_img: 'images/icons/dropdowns/reopen.png',
    archive_img: 'images/icons/dropdowns/archive.png',
    move_backlog_img: 'images/icons/board/backlog.png',
    subact_img: 'images/icons/board/subActImg.png',
    metric_upd_img: 'images/icons/metricUpdate.png',
    metric_upd_img_new: 'images/icons/update_krs.png',
    emoticon_img: 'images/goal/emoticon/50.png',
    expand_img: 'images/icons/expand.png',
    details_blue: 'images/goal/details_blue.png',
    details_grey: 'images/goal/details_grey.png',
    help_img: 'images/goal/help_small.png',
    arrow_down_blue: 'images/icons/arrow_down_blue.png',
    arrow_up_blue: 'images/icons/arrow_up_blue.png',
    themes: 'images/icons/themes.png',
    user_permissions: 'images/icons/user_permissions.png',
    add_to: 'images/icons/add@2x.png',
    manage_lifecycle: 'images/icons/manage_lifecycle.png',
    add_column: 'images/icons/add_column@2x.png',
    board_timeLine: 'images/icons/board/timeline.png',
    narrative: 'images/icons/board/narrative.png',
    date_grey: 'images/icons/date_grey.png',
    arrow_down_gray: 'images/icons/down-arrow.png',
    arrow_up_gray: 'images/icons/up_arrow.png',
    subactions_inactive: 'images/ai-v1-assets/subactions_inactive.png',
    close_topic_take: 'images/ai-v1-assets/x@2x.png',
    artboard: 'images/icons/kebab_new.png',
    recurring: 'images/Priorities/recurring.png',
    remindme: 'images/icons/dropdowns/remindme.png',
    badge: 'images/icons/dropdowns/badge.png',
    publish_meeting: 'images/icons/publish_board@2x.png',
    meetings_grey: 'images/icons/menu/icons_meet_grey.png',
    decision: 'images/meeting_assets/decision.png',
    past_meeting: 'images/icons/done_grey.png',
    close_meeting: 'images/ai-v1-assets/delete.png',
    edit_meeting: 'images/Priorities/edit_icon.png',
    view_meeting: 'images/icons/main_menu/search.png',
    up_meeting: 'images/arrow_blue_up.png',
    down_meeting: 'images/meeting_assets/blue_down_arrow copy@3x.png',
    decision_send: 'images/loadimages/decision.png',
    ai_gray: 'images/meeting_assets/ai_grey.png',
    delete_topic: 'images/ai-v1-assets/delete.png',
    ping: 'images/icons/dropdowns/ping.png',
    userImage: 'images/wb.png',
    rbrPplImage: 'images/header_assets/contributors.png',
    rbrDownArrow: 'images/arrow.png',
    rbrUpArrow: 'images/arrow_up.png',
    objImage: 'images/meeting_assets/OKR_blue@3x.png',
    keyRImage: 'images/meeting_assets/KR_blue@3x.png',
    wsImage: 'images/meeting_assets/ws_blue@3x.png',
    actionImage: 'images/meeting_assets/ai_blue@3x.png',

    asana: 'images/icons/asana.png',
    jira: 'images/icons/jira.png',
    gitHub: 'images/icons/github.png',
    high: 'images/shared_RBR/high.png',
    medium: 'images/shared_RBR/medium.png',
    action_items_empty: 'images/shared_RBR/action_items_empty.png',
    share_rbr: 'images/icons/settings/integrations.png',
    logout_pic: 'images/icons/settings/logout_pic.png',

    workboard: 'images/icons/img5_wb.png',
    next: 'images/icons/thisWeek/next.png',
    ws_sync: 'images/icons/sync_ws.png',

  };
  return (typeof imgPath[id] !== '') ? `${wbConfig.baseUrl}/${imgPath[id]}` : '';
};

/**
* @mixins WbUniqueIdMixin
* generate a uniue id.
*/
let wbUniqueId = 0;
const WbUniqueIdMixin = {
  getUniueId() {
    return ++wbUniqueId;
  },
  uniqueId(prefix) {
    return prefix + this.getUniueId();
  },
};
/**
* @mixins WbEventHandlerMixins
* event handler
*/
var WbEventHandlerMixins = {
  meetingPage(item) {
    return gotoMeetingPage(item.id);
  },
  goalPage(item) {
    const params = {};
    params.id = item.id;
    return viewGoalDetailsPage(undefined, params);
  },
  workstreamPage(item) {
    return window.open(`${wbConfig.baseUrl}/activity/workstreams?id=${item.id}`, '_blank');
  },
  goalMetricPage(item) {
    const params = {};
    params.id = item.goal_id;
    params.metricId = item.id;
    return viewGoalDetailsPage(undefined, params);
  },
  teamMemberPage(item) {
    $('#topBarOrgList').hide();
    const memberUrl = `${wbConfig.baseUrl}/workboard/actionItemList?uid=${item.userId}&type=team_members_work&tid=0&mystaff=1`;
    try {
      ajaxPageLoad(memberUrl, undefined, undefined, undefined, undefined, () => { highlightLeftMenu('menu-wb-myteam'); $('.peekMenu').hide(); });
      if (typeof history.pushState !== 'undefined') {
        const pushUrl = `${wbConfig.baseUrl}/team/teams?memberId=${item.userId}`;
        window.history.pushState({ urlPath: pushUrl }, '', pushUrl);
      }
      stateCount++;
    } catch (err) {

    }
  },
  /**
     * ping goal to user.
     */
  pingGoal(item) {
    $.post(`${wbConfig.baseUrl}/goal/sendGoalPingNotification`, { goalId: item.id }, () => {
      $('#mywobo-goals-wrapper .wspopupmenu-wrapper').hide();
    });
  },
  /**
    * copygoal.
    */
  copyGoal(item) {
    copyGoal(item.id);
  },
  /**
    * give badge.
    */
  goalBadge(item) {
    sendBadgeFun(item.teamId, item.goalOwner, undefined, item.id, undefined);
  },
  /**
    * meetingAgenda
    */
  meetingAgenda(item) {
    sendTeamAgenda(item.teamId, item.goalOwner, undefined, item.id);
  },
  /**
    * oneOnOneAgenda
    */
  oneOnOneAgenda(item) {
    send1on1Agenda(item.teamId, item.goalOwner, undefined, item.id);
  },
  getPrioText(prio) {
    let priorityValue;
    if (prio == 3) {
      priorityValue = 'Normal';
    } else if (prio == 1) {
      priorityValue = 'Highest';
    } else if (prio == 2) {
      priorityValue = 'High';
    }
    return priorityValue;
  },
  getStatusText(state) {
    let statusValue;
    if (state == 0) {
      statusValue = 'Done';
    } else if (state == 1) {
      statusValue = 'Doing';
    } else if (state == 2) {
      statusValue = 'Next';
    } else if (state == 4) {
      statusValue = 'Pending';
    }
    return statusValue;
  },
  getStateText(stateType) {
    let statusValue;
    if (stateType == '1') {
      statusValue = 'doing';
    } else if (stateType == '0') {
      statusValue = 'done';
    } else if (stateType == '4') {
      statusValue = 'pause';
    } else if (stateType == '2') {
      statusValue = 'next';
    }
    return statusValue;
  },
  getTypeText(state) {
    let statusValue;
    if (state == 0) {
      statusValue = 'done';
    } else if (state == 1) {
      statusValue = 'doing';
    } else if (state == 2) {
      statusValue = 'next';
    } else if (state == 4) {
      statusValue = 'pause';
    }
    return statusValue;
  },
  getEffortText(effort) {
    let effValue;
    if (effort == 1) {
      effValue = 'Easy';
    } else if (effort == 2) {
      effValue = 'Medium';
    } else if (effort == 3) {
      effValue = 'Huge';
    }
    return effValue;
  },
  getRagText(rag) {
    let ragValue;
    if (rag == 0) {
      ragValue = 'Green';
    } else if (rag == 1) {
      ragValue = 'Amber';
    } else if (rag == 2) {
      ragValue = 'Red';
    }
    return ragValue;
  },
  getTempAi(userDet, curDate, desc, tempId, state) {
    const tempAiArr = [];
    tempAiArr.id = tempId;
    tempAiArr.description = desc;
    tempAiArr.priority = 3;
    tempAiArr.owner_firstname = userDet.firstname;
    tempAiArr.owner_lastname = userDet.lastname;
    tempAiArr.dueDateText = curDate;
    tempAiArr.rag = 0;
    tempAiArr.state = state;

    return tempAiArr;
  },

  getTempCommentArr(commentVal, commDate, userDet, tempCommId, aiId) {
    const tempComArr = [];
    tempComArr.id = tempCommId;
    tempComArr.comment = commentVal;
    tempComArr.owner = userDet.id;
    tempComArr.act_id = aiId;
    tempComArr.firstname = userDet.firstname;
    tempComArr.lastname = userDet.lastname;
    tempComArr.ownerImage = userDet.picture;
    tempComArr.create_at_text = commDate;
    return tempComArr;
  },
  unSafeHtml(str) {
    if (str == '' || str == null) return str;
    str = str.replace(new RegExp('&#39;', 'g'), "'");
    str = str.replace(new RegExp('&#039;', 'g'), "'");
    str = str.replace(/<[^>]*>/g, ''); // strip html tags
    return str;
  },
  descAutoHeight(textarea) {
    $(textarea).each(function () {
      $(this).css({ height: 'auto', 'overflow-y': 'hidden' }).height(this.scrollHeight);
    }).on('input', function () {
      $(this).css({ height: 'auto', 'overflow-y': 'hidden' }).height(this.scrollHeight);
    });
  },
  nl2br(str) {
    if (!str || str == '') {
      return '';
    }
    const breakTag = '<br />';
    const newCont = String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
    return newCont;
  },
  openMetricUpdatePopup(metricId) {
    return openEditMetricData(metricId, metricId);
  },
  replaceTxtNotInA(html, regex, replace) {
    html = `>${html}<`;
    html = html.replace(/>([^<>]+)(?!<\/a)</g, (match, txt) => `>${txt.replace(regex, replace)}<`);
    return html.substring(1, html.length - 1);
  },
  replaceLinkWithAnchor(textValue) {
    if (typeof textValue === 'undefined' || textValue.length == 0) {
      return textValue;
    }
    let html = textValue;
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&amp;&@#\/%?=~_|!:,.;]*[-A-Z0-9+&amp;&@#\/%=~_|])/ig;
    html = WbEventHandlerMixins.replaceTxtNotInA(html, exp, "<a href='$1' target='_blank'>$1</a>");
    const exp2 = /\b(www\.[\S]+)\b/gi;
    html = WbEventHandlerMixins.replaceTxtNotInA(html, exp2, '<a href="http://$1" target="_blank">$1</a>');
    return html;
  },
  aiDetailPage(aiId, obj, viewAccess) {
    if (viewAccess == 'false') {
      return;
    }
    const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
    if (urlVal && aiId && obj) {
      /* if(typeof getAppContext !== 'undefined' && getAppContext() == 'msteams'){
                urlVal = wbConfig.baseUrl + '/activity/mywork?do=popup&id='+ aiId;
                return window.open(urlVal, 'openai');
            } */
      return openFullPopUp(aiFullViewPopUp, urlVal, $(obj));
    }
  },
};
/**
* html markdown
* use Reactjs dangerouslySetInnerHTML
*/
const WbMarkdownHtml = function (content) {
  return { __html: content };
};

/**
* This method is used to load the component to dom in wobo rbr page.
*/
const woboPageLoadComponent = function (loadComp) {
  const { t } = useTranslation();
  const load_components = loadComp || [];
  let allComponents = {
    mywoborbr_mainmenu: <MyRbrTopMenu t={t}/>,
    mywoborbr_hotbox_wrapper: <HotboxListComp title="Hotbox" />,
  };
  const enableModules = wbConfig.enableModules || {};
  if (typeof enableModules.goal !== 'undefined' && enableModules.goal != 0) {
    allComponents.mywobo_metric_wrapper = <WbSliderComp title="Metric list" t={t}/>;
    allComponents.mywobo_goals_wrapper = <GoalListsComp title={`${t('Objectives')}`} t={t} />;
  }
  if ((typeof enableModules.execute !== 'undefined' && enableModules.execute != 0)) {
    allComponents.mywobo_ws_wrapper = <WsListsComp title="Workstreams" t={t}/>;
  }
  if ((typeof enableModules.execute !== 'undefined' && enableModules.execute != 0) || (typeof enableModules.meeting !== 'undefined' && enableModules.meeting != 0)) {
    allComponents.mywoborbr_today_wrapper = <AIwithCalendarView title="today" type="today" />;
    allComponents.mywoborbr_tomorrow_wrapper = <AIwithCalendarView title="tomorrow" type="tomorrow" />;
  }

  if (load_components.length) {
    const load_c = {};
    if (typeof load_components === 'object') {
      for (const k in load_components) {
        const key = load_components[k];
        if (typeof allComponents[key] !== 'undefined') {
          load_c[key] = allComponents[key];
          if (key == 'mywobo_goals_wrapper') {
            cacheRbrGoal = [];
          }
          if (key == 'mywobo_ws_wrapper') {
            cacheRbrWs = [];
          }
          if (key == 'mywobo_metric_wrapper') {
            cacheRbrMetric = [];
          }
          if (key == 'mywoborbr_hotbox_wrapper') {
            cacheRbrHotBox = [];
          }
        }
      }
      allComponents = load_c;
    }
  }
  if (Object.keys(allComponents).length) {
    for (const i in allComponents) {
      if (typeof allComponents[i] !== 'undefined') {
        const id = i.replace(/_/g, '-');
        const mountId = document.getElementById(id);
        if (mountId) {
          ReactDOM.unmountComponentAtNode(mountId);
          ReactDOM.render(allComponents[i], mountId);
        }
      }
    }
  }
};

/**
* Go to meeting page.
*/
var gotoMeetingPage = function (id) {
  const url = `${wbConfig.baseUrl}/meeting/meetingDetails?id=${id}`;
  window.open(url, 'openmeeting');
  return false;
};

const convertDateFromTimestamp = function (timestamp) {
  if (timestamp == null || timestamp == '') {
    return '';
  }
  const offset = 0;
  const t = parseInt(timestamp) + offset;
  if (t == 0 || t == 'NaN') {
    return '';
  }
  const d = new Date(t * 1000);
  const dateString = d.toString();
  if (dateString == 'Invalid Date') {
    return '';
  }
  const s = dateString.split(' ');
  return `${s[1]} ${s[2]} ‘${s[3].substring(2)}`;
};

/**
* Create a component for rectbox precentage.
*/
class RectBoxPercentage extends React.Component {
  constructor(props) {
    super(props);
    this.getPercentage = this.getPercentage.bind(this);
  }

  getPercentage(value) {
    return ((value.indexOf('-1') >= 0 || value < 0) ? '--' : value);
  }

  render() {
    return (
      <div className="rectbox-percentage" style={{ background: this.props.style.color }}>
        <div>{this.getPercentage(this.props.count)}</div>
      </div>
    );
  }
}


/**
* Loading component
*/
const LoaderComp = function (props) {
  return (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);
};

/*
* Create a component popup for add goal/ws item to goal/ws tray.
*/
class AddItemPopupList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalBoxContianer: this.getProps().modalBoxContianer || null,
      addItemList: this.getProps().items || [],
      initialItems: this.getProps().items || [],
      searchText: '',
    };
    this.getProps = this.getProps.bind(this);
    this.searchText = this.searchText.bind(this);
    this.filteredData = this.filteredData.bind(this);
    this.closeModalBox = this.closeModalBox.bind(this);
    this.addItemToYourRBR = this.addItemToYourRBR.bind(this);
    this.addRbrGoal = this.addRbrGoal.bind(this);
  }

  getProps() {
    return this.props.props;
  }

  searchText(e) {
    this.state.searchText = e.target.value;
    const filteredDataList = this.state.initialItems.filter(this.filteredData);
    this.setState({
      addItemList: filteredDataList,
    });
  }

  filteredData(item) {
    const { searchText } = this.state;
    if (searchText != '') {
      let itemTitle = '';
      const searchTextLowerCase = searchText.toLowerCase().split(' ');
      if (this.getProps().type == 'goal') {
        itemTitle = item.goal.toLowerCase();
        const ownerTitle = item.owner.toLowerCase();
        const ownerFullName = (typeof item.fullName !== 'undefined') ? item.fullName.toLowerCase() : '';
        return searchTextLowerCase.every(e1 => itemTitle.indexOf(e1) > -1 || ownerTitle.indexOf(e1) > -1 || ownerFullName.indexOf(e1) > -1);
      }
      if (this.getProps().type == 'ws') {
        itemTitle = item.name.toLowerCase();
      }
      return searchTextLowerCase.every(el => itemTitle.indexOf(el) > -1);
    }

    return true;
  }

  closeModalBox(e, item) {
    return this.getProps().closeModalBox(e, item);
  }

  addItemToYourRBR(item, event) {
    this.closeModalBox(event, item);
  }

  addRbrGoal(e) {
    const filteredItems = this.state.initialItems.filter(item => (!!item.checked));
    const checkedValues = filteredItems.map(it => it.id);
    $('.wbmodal-goal .errormsg').hide();
    if (checkedValues.length == 0) {
      $('.wbmodal-goal .errormsg').show().html('Please select atleast one goal.');
      return;
    }

    const _item = {
      addMultipleGoals: 1,
      goals: checkedValues,
    };
    return this.closeModalBox(e, _item);
  }

  render() {
    const { t } = this.props;

    const modalClass = `wbmodal-${this.getProps().type}`;
    const _type = this.getProps().type;
    const placeholerText = _type == 'goal' ? `Search by ${t('objective')} or owner` : 'Search';
    return (
      <div className={`wbmodal ${modalClass}`}>
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            {this.getProps().title}
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={this.closeModalBox}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content">
          <div className="addwoboitem-text-wrapper">
            <input type="text" name="s" placeholder={placeholerText} onChange={this.searchText} />
            <div className="errormsg" />
          </div>
          <div className="addwoboitem-wrapper" data-testid="addwoboitem-wrapper">
            {_type == 'goal'
              ? this.state.addItemList.map((item, index) => (
                <GoalListCompRow goal={item} showCheckbox="1" parent={this} t={t} />
              ))
              : this.state.addItemList.map((item, index) => (
                <WsListsRowComp ws={item} rowClick={this.addItemToYourRBR} t={t} />
              ))
                   }
          </div>
          { _type == 'goal' && this.state.addItemList.length ? <div className="gbl-btn" onClick={this.addRbrGoal}>Add</div> : ''}
        </div>
      </div>
    );
  }
}

/*
* Create a component for three dot menu.
*/
class HamburgMenuComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: this.props.menu || false,
    };
    this.handler = this.handler.bind(this);
    this.handlerAjaxMenu = this.handlerAjaxMenu.bind(this);
    this.mouseover = this.mouseover.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const source = nextProps.source || false;
    if (source == 'board_top_menu') {
      this.setState({ menus: nextProps.menu });
    }
  }

  handler(item) {
    if (item.handler !== 'undefined') {
      return item.handler(item.item);
    }

    return false;
  }

  handlerAjaxMenu(item, parentObj) {
    const _this = this;

    const { t } = _this.props;
    showLoaderWidget($('#content'));
    $.ajax({
      url: `${wbConfig.baseUrl}/rbr/ShowGoalMenuItems`,
      type: 'get',
      data: { goalId: item.id },
    })
      .done((response) => {
        if (response.status == 'success') {
          const { goalMenuItems } = response;
          if (goalMenuItems) {
            const goalId = goalMenuItems.id;
            const { removeFromTray } = goalMenuItems;
            const { edit } = goalMenuItems;
            const deleteGoal = goalMenuItems.delete;
            const { show_ping } = goalMenuItems;
            const { closeGoal } = goalMenuItems;
            const { copyGoal } = goalMenuItems;
            const { giveBadge } = goalMenuItems;
            const { meetingAgenda } = goalMenuItems;
            const { oneOnOneAgenda } = goalMenuItems;
            const menu = {};
            menu.items = [
            ];
            if (removeFromTray) {
              menu.items.push({
                title: 'Remove from tray',
                handler: parentObj.props.handlers.removeFromTray,
                item,
                pic: 'removefromtray_img',
              });
            }
            if (edit) {
              menu.items.push({
                title: 'Edit',
                handler: parentObj.props.handlers.editGoal,
                item,
                pic: 'edit_img',
              });
            }
            if (deleteGoal) {
              menu.items.push({
                title: 'Delete',
                handler: parentObj.props.handlers.delGoal,
                item,
                pic: 'delete_img',
              });
            }
            if (closeGoal) {
              menu.items.push({
                title: `Close ${t('Objective')}`,
                handler: parentObj.props.handlers.closeGoal,
                item,
                pic: 'closegoal_img',
              });
            }
            if (copyGoal) {
              menu.items.push({
                title: `Copy ${t('Objective')}`,
                handler: WbEventHandlerMixins.copyGoal,
                item,
                pic: 'copy_img',
              });
            }
            if (show_ping) {
              menu.items.push({
                title: 'Ping',
                handler: WbEventHandlerMixins.pingGoal,
                item,
                pic: 'ping_img',
              });
            }
            if (giveBadge) {
              menu.items.push({
                title: t('Give Feedback'),
                handler: WbEventHandlerMixins.goalBadge,
                item,
                pic: 'badge_img',
              });
            }
            if (meetingAgenda) {
              menu.items.push({
                title: 'Meeting Agenda',
                handler: WbEventHandlerMixins.meetingAgenda,
                item,
                pic: 'addtomeet_img',
              });
            }
            if (oneOnOneAgenda) {
              menu.items.push({
                title: '1on1 Agenda',
                handler: WbEventHandlerMixins.oneOnOneAgenda,
                item,
                pic: 'addto1on1_img',
              });
            }
            _this.setState({
              menus: menu,
            });
            $(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${response.goalMenuItems.id}"]`).show();
          }
        }
      })
      .always((response) => {
        removeLoaderWidget();
      });
  }

  mouseover() {}

  render() {
    const { t } = this.props;

    const mainmenu = this.state.menus.mainmenu || false;
    const menuAjaxLoad = this.props.menuAjax || false;
    let classNames = ' clickable ';
    if (menuAjaxLoad) {
      classNames = ' cursorPointer ';
    }
    const submenu = this.state.menus.submenu || false;
    return (
      <div className="wbpopumenu">
        {(!submenu)
          ? (
            <div
              className={`wbpopupmenu-ops ${(mainmenu) ? 'wbpopupmenuMain-ops ' : ''}  alignCenter ${classNames}`}
              onClick={menuAjaxLoad ? () => this.handlerAjaxMenu(this.props.item, this.props.parentObj) : ''}
            >
                    &nbsp;
            </div>
          )
          : ''
            }
        <div className="wspopupmenu-wrapper" data-id={this.props.item ? this.props.item.id : ''} onMouseOver={this.mouseover}>
          {this.state.menus ? this.state.menus.items.map((item, index) => (
            <div className=" wspopupmenu-list clickable imageWebkit" onClick={() => this.handler(item)}>
              {item.pic ? <ImgIconComp class={item.img_class ? 'pictureClass' : 'wspopmenuImage'} id={item.pic} width={item.width ? item.width : '15'} height={item.height ? item.height : '15'} /> : ''}
              <div className={item.class ? `wspopupmenulabel ${item.class}` : 'wspopupmenulabel'}>{item.title}</div>

              { item.submenu && item.submenu.length
                            && (
                            <div className="submenu">
                              <HamburgMenuComp menu={{ items: item.submenu, mainmenu: 1, submenu: 1 }} source="board_top_menu" t={t} />
                            </div>
                            )
                        }

            </div>
          )) : ''}
        </div>
      </div>
    );
  }
}

/**
* create a component for displaying the goal list in row.
*/
class GoalListCompRow extends React.Component {
  constructor(props) {
    super(props);
    this.isRowClickable = this.isRowClickable.bind(this);
    this.rowClickHandler = this.rowClickHandler.bind(this);
    this.viewGoalPage = this.viewGoalPage.bind(this);
    this.rowMouseLeave = this.rowMouseLeave.bind(this);
    this.toggleChkBox = this.toggleChkBox.bind(this);
  }

  isRowClickable() {
    return this.props.rowClick || false;
  }

  rowClickHandler() {
    if (this.isRowClickable()) {
      return this.props.rowClick(this.props.goal);
    }
    return false;
  }

  viewGoalPage(item) {
    const showMenu = this.props.showMenu || false;
    if (showMenu) {
      return WbEventHandlerMixins.goalPage(item);
    }
    return false;
  }

  rowMouseLeave(item) {
    const showMenu = this.props.showMenu || false;
    if (showMenu) {
      $('.rectbox-hover-row-table .wspopupmenu-wrapper').hide();
    }
  }

  toggleChkBox(e, item) {
    const goals = this.props.parent.state.initialItems.map((it) => {
      if (it.id == item.id) {
        it.checked = e.target.checked;
      }
      return it;
    });
    this.props.parent.setState({ initialItems: goals });
  }

  render() {
    const { t } = this.props;

    const item = this.props.goal;
    const index = this.props.key;
    const rowClick = this.isRowClickable();
    const showMenu = this.props.showMenu || false;
    const percentageStyles = {
      color: item.color,
    };
    const recentComment = (typeof item.RecentGoalComment !== 'undefined') ? item.RecentGoalComment : [];
    const commentShow = {
      display: (recentComment.length && showMenu) ? 'block' : 'none',
    };
    const rowClass = (rowClick) ? ' clickable ' : '';
    const sortableItemClass = this.props.sortableItem == 1 ? ' gtray-sortable-item ' : '';
    const showCheckbox = this.props.showCheckbox == 1;
    let comment = '';
    if (recentComment.length && showMenu) {
      const aa = item.RecentGoalComment[0];
      comment = (typeof aa[0].comment !== 'undefined') ? aa[0].comment : '';
    }
    return (
      <div className={`rectbox-row ${rowClass}${sortableItemClass}`} key={showCheckbox ? item.id : index} data-id={item.id} onMouseLeave={() => this.rowMouseLeave(item)} onClick={this.rowClickHandler}>
        {
                    showCheckbox && (
                    <div className="rectbox-col">
                      <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                        <input type="checkbox" className="css-checkbox" checked={item.checked} onChange={e => this.toggleChkBox(e, item)} value={item.id} name="goals[]" id={`goal-chk-${item.id}`} />
                        <label className="css-label modalParaText" htmlFor={`goal-chk-${item.id}`} />
                      </div>
                    </div>
                    )
                }
        <div className="rectbox-col">
          <RectBoxPercentage count={item.progress} style={{ color: item.progress_color }} />
        </div>
        <div className="rectbox-col rectbox-col-goal rectbox-col-line">
          <div className="rectbox-title"  data-testid="rectbox-title">
            <span className={(showMenu ? ' clickable ' : '')} onClick={() => this.viewGoalPage(item)}>
              {item.goal}
            </span>
          </div>
          <div className="rectbox-subtitle">
            <div dangerouslySetInnerHTML={WbMarkdownHtml(item.team ? `${item.team}: ${item.owner}` : item.owner)} />
          </div>
          <div className="rectbox-comment" style={commentShow}>
            <div dangerouslySetInnerHTML={WbMarkdownHtml(comment)} />
          </div>
        </div>
        {showMenu && <div className="rectbox-col rectbox-col-line rectbox-col-showmenu"><HamburgMenuComp menuAjax={this.props.menuAjax} item={item} parentObj={this} t={t} /></div>}
      </div>
    );
  }
}

/*
* Goal tray component.
*/
class GoalListsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goals: [],
      currentUserId: null,
      modalBoxContianer: null,
      loading: true,
    };
    this.registerSortable = this.registerSortable.bind(this);
    this.openModalBox = this.openModalBox.bind(this);
    this.closeModalBox = this.closeModalBox.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.removeFromTray = this.removeFromTray.bind(this);
    this.editGoal = this.editGoal.bind(this);
    this.delGoal = this.delGoal.bind(this);
    this.closeGoal = this.closeGoal.bind(this);
    this.emptyContent = this.emptyContent.bind(this);
  }

  componentDidMount() {
    const _this = this;
    if (typeof wbConfig.baseUrl !== 'undefined') {
      if (cacheRbrGoal.length) {
        _this.setState({
          goals: cacheRbrGoal || [],
          currentUserId: cacheCurrentUserId,
          loading: false,
        });
        setTimeout(() => _this.registerSortable(), 100);
      } else {
        $.ajax({
          url: `${wbConfig.baseUrl}/rbr/getMyRbrGoals`,
          type: 'get',
        })
          .done((response) => {
            if (response.status == 'success') {
              _this.setState({
                goals: response.goals,
                currentUserId: response.currentUserId,
                loading: false,
              });
              _this.registerSortable();
            }
          });
      }
    }
  }

  registerSortable() {
    let oldItemPosition; const _this = this;
    $('.gtray-sortable').sortable({
      axis: 'y',
      items: '.gtray-sortable-item',
      opacity: 0.8,
      cursor: 'move',
      containment: 'parent',
      tolerance: 'pointer',
      cancel: ':input,button,[contenteditable]',
      update(event, ui) {
        const goalIds = $('.gtray-sortable').sortable('toArray', { attribute: 'data-id' });
        if (goalIds.length) {
          $.post(`${wbConfig.baseUrl}/rbr/saveRbrGoalSorting`, { goalIds });
          const results = [];
          goalIds.forEach((k) => {
            const found = _this.state.goals.find(it => it.id == k);
            if (found) {
              results.push(found);
            }
          });
          _this.setState({ goals: [] });
          setTimeout(() => { _this.setState({ goals: results }); }, 0);
        }
      },
    });
  }

  /**
     * open popup for add goal to tray.
     */
  openModalBox() {
    const { t } = this.props;
    self = this;
    if (self.state.modalBoxContianer == null) {
      self.state.modalBoxContianer = $(woboAddGoalPopup).attr('id');
      $.get(`${wbConfig.baseUrl}/rbr/getMyGoals`)
        .then((res) => {
          woboAddGoalPopup.dialogOpen();
          let goals = res.goals || [];
          goals = goals.map((it) => { it.checked = 0; return it; });
          const props = {
            items: goals,
            type: 'goal',
            title: `${t('Add an')} ${t('objective')}`,
            closeModalBox: self.closeModalBox,
            modalBoxContianer: self.state.modalBoxContianer,
          };
          ReactDOM.render(<AddItemPopupList props={props} t={t} />, document.getElementById(self.state.modalBoxContianer));
        });
    }
  }

  /**
     * close add goal tray popup
     */
  closeModalBox(e, item) {
    $(woboAddGoalPopup).dialog('close');
    if (this.state.modalBoxContianer !== null) {
      if (document.getElementById(this.state.modalBoxContianer)) {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.state.modalBoxContianer));
      }
    }
    this.state.modalBoxContianer = null;
    if (typeof item === 'object') {
      self = this;
      if (typeof item.addMultipleGoals !== 'undefined') {
        $.post(`${wbConfig.baseUrl}/rbr/addRbrGoals`, { goals: item.goals }, (response) => {
          const _goals = response.goals || [];
          if (_goals.length) {
            const modifiedGoals = self.state.goals.filter(it => item.goals.indexOf(it.id) == -1);
            $(_goals).each((i, _goal) => {
              modifiedGoals.push(_goal);
            });
            self.setState({
              goals: modifiedGoals,
            });
          }
        });
      } else {
        $.get(`${wbConfig.baseUrl}/rbr/addRbrGoal`, { goalId: item.id })
          .then((response) => {
            const _goal = response.goal || [];
            const modifiedGoals = self.state.goals.filter(it => it.id != item.id);
            if (Object.keys(_goal).length) {
              modifiedGoals.push(_goal);
            }
            self.setState({
              goals: modifiedGoals,
            });
          });
      }
    }
  }

  /**
     * hide hamburg menu.
     */
  hideMenu() {
    $('#mywobo-goals-wrapper .wspopupmenu-wrapper').hide();
  }

  /**
     * remove goal from tray.
     */
  removeFromTray(item) {
    if (item.id) {
      self = this;
      $.get(`${wbConfig.baseUrl}/rbr/removeRbrGoal`, { goalId: item.id })
        .then((response) => {
          const goals = self.state.goals.filter(it => it.id != item.id);
          self.setState({
            goals,
          });
          self.hideMenu();
        });
    }
  }

  /**
     * edit goal.
     */
  editGoal(item) {
    self = this;
    const myGoal = (item.type == 2) ? '1' : '0';
    const tid = item.teamId;
    const gid = item.id;
    const metricTeamOpen = `team-goal-${item.id}`;
    openEditGoalPopup(myGoal, undefined, tid, gid, metricTeamOpen);
  }

  /**
     * delete goal.
     */
  delGoal(item) {
    self = this;
    goal_delet_confirm.data('goalId', item.id).data('enable', 1).dialogOpen();
  }

  /**
     * close goal.
     */
  closeGoal(item) {
    self = this;
    closeGoal(item.id);
  }

  /**
     * empty content
     */
  emptyContent() {
    const { t } = this.props;

    if (!this.state.goals.length) {
      return (
        <div className="wbwobo-empty-wrapper">
          <div className="wbwobo-empty-icon-wrapper">
            <ImgIconComp id="goals_empty" width="20" height="20" />
          </div>
          <div className="wbwobo-empty-content-wrapper">
                    Add {t('objectives')} to watch by tapping
                    on the
            {' '}
            <ImgIconComp id="blue_additem" width="20" height="20" />
            {' '}
            symbol.
          </div>
        </div>
      );
    }
  }

  render() {
    const { t } = this.props;

    const handlers = {
      removeFromTray: this.removeFromTray,
      pingGoal: this.pingGoal,
      editGoal: this.editGoal,
      goalBadge: this.goalBadge,
      copyGoal: this.copyGoal,
      closeGoal: this.closeGoal,
      delGoal: this.delGoal,
      meetingAgenda: this.meetingAgenda,
      oneOnOneAgenda: this.oneOnOneAgenda,
    };
    const sortableItem = this.state.goals.length > 1 ? 1 : 0;
    const sortableItemClass = sortableItem ? ' gtray-sortable ' : '';
    return (
      <div className={`rectbox-table recboxshadow rectbox-hover-row-table ${sortableItemClass}`} ref="goalList">
        <div className="rectbox-row rectbox-header">
          <div className="rectbox-htitle">
            {this.props.title}
          </div>
          <div className="rectbox-addicon clickable" onClick={this.openModalBox}>
            <ImgIconComp id="add" />
          </div>
        </div>
        {
              this.state.loading && <LoaderComp />
            }
        {
              !this.state.loading && (this.emptyContent()
                || this.state.goals.map((item, index) => (
                  <GoalListCompRow goal={item} currentUserId={this.state.currentUserId} showMenu="1" menuAjax="1" handlers={handlers} sortableItem={sortableItem} t={t} />
                )))
           }

      </div>
    );
  }
}

/**
* Donut circle component.
*/
class BarChartComp extends React.Component {
  constructor(props) {
    super(props);
    this.getCount = this.getCount.bind(this);
    this.getLabelText = this.getLabelText.bind(this);
    this.getStrokeDashOffset = this.getStrokeDashOffset.bind(this);
    this.getCircleCircumference = this.getCircleCircumference.bind(this);
  }

  getCount() {
    const { count } = this.props;
    return count > 100 ? 100 : count;
  }

  getLabelText() {
    return this.getCount();
  }

  getStrokeDashOffset() {
    return (((100 - this.getCount()) / 100) * (Math.PI * 2 * this.props.radius));
  }

  getCircleCircumference() {
    return (2 * Math.PI * this.props.radius).toFixed(2);
  }

  render() {
    var count = this.getCount();
    var count = count < 0 ? '--' : count;
    const { color } = this.props;
    const { radius } = this.props;
    const { width } = this.props;
    const { height } = this.props;
    const xDivide = Math.round(width / 2);

    const wrapperStyle = { color };
    const strokeStyle = {
      'stroke-width': 4,
      'stroke-dashoffset': `${this.getStrokeDashOffset()}px`,
      'stroke-dasharray': this.getCircleCircumference(),
      stroke: color,
    };
    const circleStyle = {
      'stroke-width': 5,
      'stroke-dashoffset': 0,
      'stroke-dasharray': this.getCircleCircumference(),
      stroke: '#BBBBBB',
    };
    const transform = {

    };
    return (
      <div className="goal-donut-circle barchartcomp-wrapper" data-pct={count} style={wrapperStyle}>
        <svg width={width} height={height} version="1.1" xmlns="http://www.w3.org/2000/svg">
          <circle r={radius} cx={xDivide} cy={xDivide} fill="transparent" style={circleStyle} />
          <circle r={radius} cx={xDivide} cy={xDivide} fill="transparent" transform={`rotate(270,${xDivide},${xDivide})`} style={strokeStyle} />
        </svg>
      </div>
    );
  }
}

BarChartComp.defaultProps = {
  count: 0,
  color: '#db3a1b',
  radius: '18',
  width: '42',
  height: '42',
};

/**
* This component is used to get an image tag.
*/
class ImgIconComp extends React.Component {
  constructor(props) {
    super(props);
    this.getWidth = this.getWidth.bind(this);
    this.getHeight = this.getHeight.bind(this);
    this.getClass = this.getClass.bind(this);
    this.getIconPath = this.getIconPath.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  componentDidMount() {
  }

  getWidth() {
    const w = this.props.width;
    return w;
  }

  getHeight() {
    const h = this.props.height;
    return h;
  }

  getClass() {
    const c = this.props.class ? this.props.class : '';
    return c;
  }

  getDataAttr() {
    const c = this.props.attr ? this.props.attr : '';
    return c;
  }

  getIconPath(id) {
    return IconPathComp(id);
  }

  getTitle() {
    const c = this.props.title ? this.props.title : '';
    return c;
  }

  render() {
    let inlineStyle = {};
    if (typeof this.props.style === 'object') {
      inlineStyle = this.props.style;
    }
    return (
      <img
        src={this.props.srcUrl ? this.props.srcUrl : this.getIconPath(this.props.id)}
        data-attr={this.getDataAttr()}
        className={this.getClass()}
        width={this.getWidth()}
        height={this.getHeight()}
        title={this.getTitle()}
        style={inlineStyle}
      />
    );
  }
}

ImgIconComp.defaultProps = {
  width: 15,
  height: 15,
};

/**
* This component is used to get an image with count.
*/
class IconCountComp extends React.Component {
  constructor(props) {
    super(props);
    this.getCount = this.getCount.bind(this);
  }

  getCount() {
    return (typeof this.props.count && this.props.count > 0) ? this.props.count : 0;
  }

  render() {
    const count = this.getCount();
    const { imgWidth } = this.props;
    const { imgHeight } = this.props;
    if (this.props.hideNone && count == 0) {
      return null;
    }
    return (
      <div className="iconcountcomp-wrapper">
        <div className="iconcountcomp-counttext left"><div>{this.getCount()}</div></div>
        <div className="iconcountcomp-icon right" style={{ padding: '5px 10px 0 0' }}><ImgIconComp id={this.props.iconPath} width={imgWidth} height={imgHeight} /></div>
        <div className="clear" />
      </div>
    );
  }
}
IconCountComp.defaultProps = {
  count: 0,
  iconPath: '',
  hideNone: 1,
  imgWidth: 13,
  imgHeight: 13,
};


/**
* This component is used to display the ws list in row.
*/
class WsListsRowComp extends React.Component {
  constructor(props) {
    super(props);
    this.isRowClickable = this.isRowClickable.bind(this);
    this.rowClickHandler = this.rowClickHandler.bind(this);
    this.viewWsPage = this.viewWsPage.bind(this);
    this.rowMouseLeave = this.rowMouseLeave.bind(this);
  }

  isRowClickable() {
    return this.props.rowClick || false;
  }

  rowClickHandler() {
    if (this.isRowClickable()) {
      return this.props.rowClick(this.props.ws);
    }
    return false;
  }

  viewWsPage(item) {
    const showMenu = this.props.showMenu || false;
    if (showMenu) {
      return WbEventHandlerMixins.workstreamPage(item);
    }
    return false;
  }

  rowMouseLeave(item) {
    const showMenu = this.props.showMenu || false;
    if (showMenu) {
      $('.rectbox-hover-row-table .wspopupmenu-wrapper').hide();
    }
  }

  render() {
    const { t } = this.props;

    const item = this.props.ws;
    const { index } = this.props;
    const rowClick = this.isRowClickable();
    const showMenu = this.props.showMenu || false;
    const menu = {};
    let rowClass = '';
    if (rowClick) {
      rowClass = ' clickable ';
    }
    if (showMenu) {
      menu.items = [
        {
          title: 'Remove from tray',
          handler: this.props.handlers.removeFromTray,
          item,
          pic: 'removefromtray_img',
        },
      ];
    }
    const sortableItemClass = this.props.sortableItem == 1 ? ' wtray-sortable-item ' : '';
    const leader = (typeof item.leader !== 'undefined') ? item.leader : '';
    const labelText = (item.team) ? item.team + (leader ? `: ${leader}` : '') : leader;
    return (
      <div className={`rectbox-row${rowClass}${sortableItemClass}`} key={index} data-id={item.id} onMouseLeave={() => this.rowMouseLeave(item)} onClick={this.rowClickHandler}>
        <div className="rectbox-col">
          <BarChartComp count={item.progress} color={item.progress_color} />
        </div>
        <div className="rectbox-col rectbox-col-name rectbox-col-line">
          <div className="rectbox-title"  data-testid="rectbox-title">
            <span className={(showMenu ? ' clickable ' : '')} onClick={() => this.viewWsPage(item)}>
              {WbEventHandlerMixins.unSafeHtml(item.name)}
            </span>
          </div>
          <div className="rectbox-subtitle">
            {labelText}
          </div>
        </div>
        {
                showMenu
                && (
                <div className="rectbox-col rectbox-col-iconcount rectbox-col-line">
                  <IconCountComp count={item.reds} iconPath="red" />
                </div>
                )
            }
        { showMenu
                && (
                <div className="rectbox-col rectbox-col-iconcount rectbox-col-line">
                  <IconCountComp count={item.late} iconPath="late" />
                </div>
                )
            }
        { showMenu
                && (
                <div className="rectbox-col rectbox-col-iconcount rectbox-col-line">
                  <IconCountComp count={item.doing} iconPath="doing" />
                </div>
                )
            }
        { showMenu
                && (
                <div className="rectbox-col rectbox-col-ws-enddate rectbox-col-line">
                  <div className="rectbox-ws-enddate">{item.target_date_text}</div>
                </div>
                )
            }
        { showMenu
                && <div className="rectbox-col rectbox-col-line rectbox-col-showmenu"><HamburgMenuComp menu={menu} t={t} /></div>
            }
      </div>
    );
  }
}

/**
* Workstream tray component.
* This component is used to display ws lists(ws tray).
*/
class WsListsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wsItems: [],
      modalBoxContianer: null,
      loading: true,
    };
    this.registerSortable = this.registerSortable.bind(this);
    this.openModalBox = this.openModalBox.bind(this);
    this.closeModalBox = this.closeModalBox.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.removeFromTray = this.removeFromTray.bind(this);
    this.emptyContent = this.emptyContent.bind(this);
  }

  componentDidMount() {
    const _this = this;
    if (typeof wbConfig.baseUrl !== 'undefined') {
      if (cacheRbrWs.length) {
        _this.setState({
          wsItems: cacheRbrWs,
          loading: false,
        });
        setTimeout(() => _this.registerSortable(), 100);
      } else {
        $.ajax({
          url: `${wbConfig.baseUrl}/rbr/getMyRbrWs`,
          type: 'get',
        })
          .done((response) => {
            if (response.status == 'success') {
              _this.setState({
                wsItems: response.ws,
                loading: false,
              });
              _this.registerSortable();
            }
          });
      }
    }
  }

  registerSortable() {
    let oldItemPosition; const _this = this;
    $('.wtray-sortable').sortable({
      axis: 'y',
      items: '.wtray-sortable-item',
      opacity: 0.8,
      cursor: 'move',
      containment: 'parent',
      tolerance: 'pointer',
      cancel: ':input,button,[contenteditable]',
      update(event, ui) {
        const wsIds = $('.wtray-sortable').sortable('toArray', { attribute: 'data-id' });
        if (wsIds.length) {
          $.post(`${wbConfig.baseUrl}/rbr/saveRbrWsSorting`, { wsIds });
          const results = [];
          wsIds.forEach((k) => {
            const found = _this.state.wsItems.find(it => it.id == k);
            if (found) {
              results.push(found);
            }
          });
          _this.setState({ wsItems: [] });
          setTimeout(() => { _this.setState({ wsItems: results }); }, 0);
        }
      },
    });
  }

  openModalBox() {
    const { t } = this.props;
    self = this;
    if (self.state.modalBoxContianer == null) {
      self.state.modalBoxContianer = $(woboAddGoalPopup).attr('id');
      $.get(`${wbConfig.baseUrl}/rbr/getMyWsLists`)
        .then((res) => {
          woboAddGoalPopup.dialogOpen();
          const ws = res.ws || [];
          const props = {
            items: ws,
            type: 'ws',
            title: 'Add a Workstream to Your RBR',
            closeModalBox: self.closeModalBox,
            modalBoxContianer: self.state.modalBoxContianer,
          };
          ReactDOM.render(<AddItemPopupList props={props} t={t}/>, document.getElementById(self.state.modalBoxContianer));
        });
    }
  }

  closeModalBox(e, item) {
    $(woboAddGoalPopup).dialog('close');
    if (this.state.modalBoxContianer !== null) {
      if (document.getElementById(this.state.modalBoxContianer)) {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.state.modalBoxContianer));
      }
    }
    this.state.modalBoxContianer = null;
    if (typeof item === 'object') {
      const _self = this;
      $.get(`${wbConfig.baseUrl}/rbr/addRbrWs`, { wsId: item.id })
        .then((response) => {
          const ws = response.ws || [];
          const modifiedWs = _self.state.wsItems.filter(it => it.id != item.id);
          if (Object.keys(ws).length) {
            modifiedWs.push(ws);
          }
          _self.setState({
            wsItems: modifiedWs,
          });
        });
    }
  }

  hideMenu() {
    $('#mywobo-goals-wrapper .wspopupmenu-wrapper').hide();
  }

  removeFromTray(item) {
    if (item.id) {
      const _self = this;
      $.get(`${wbConfig.baseUrl}/rbr/removeRbrWs`, { wsId: item.id })
        .then((response) => {
          const wsItems = _self.state.wsItems.filter(it => it.id != item.id);
          _self.setState({
            wsItems: [],
          });
          _self.setState({
            wsItems,
          });
          _self.hideMenu();
        });
    }
  }

  emptyContent() {
    if (!this.state.wsItems.length) {
      return (
        <div className="wbwobo-empty-wrapper">
          <div className="wbwobo-empty-icon-wrapper">
            <ImgIconComp id="ws_empty" width="20" height="20" />
          </div>
          <div className="wbwobo-empty-content-wrapper">
                        Add workstreams to watch by tapping
                        on the
            {' '}
            <ImgIconComp id="blue_additem" width="20" height="20" />
            {' '}
symbol.
          </div>
        </div>
      );
    }
  }

  render() {
    const { t } = this.props;

    const handlers = { removeFromTray: this.removeFromTray };
    const sortItems = this.state.wsItems.length ? 1 : 0;
    const sortableItemClass = sortItems ? ' wtray-sortable ' : '';
    return (
      <div className={`rectbox-table recboxshadow rectbox-hover-row-table rectbox-hover-row-option${sortableItemClass}`}>
        <div className="rectbox-row rectbox-header">
          <div className="rectbox-htitle">
            { this.props.title}
          </div>
          <div className="rectbox-addicon clickable" onClick={this.openModalBox}>
            <ImgIconComp id="add" />
          </div>
        </div>
        {
                this.state.loading && <LoaderComp />
            }
        {
                !this.state.loading && (this.emptyContent()
                || this.state.wsItems.map((item, index) => (
                  <WsListsRowComp ws={item} index={index} showMenu="1" handlers={handlers} sortableItem={sortItems} t={t} />
                ))
                )
            }
      </div>
    );
  }
}

/**
* MeetRowComp component
*/
class MeetRowComp extends React.Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
  }

  handler() {
    return gotoMeetingPage(this.props.item.id);
  }

  render() {
    const { item } = this.props;
    const { type } = this.props;
    return (
      <div className="rectbox-row" key={`meet_${type}${item.id}`}>
        <div className="rectbox-col rectbox-col-line rectbox-col-mdatetime">
          <div className="rectbox-mdatetime">
            {item.mdatetime}
          </div>
        </div>
        <div className="rectbox-col rectbox-col-line rectbox-col-mname">
          <div className="rectbox-mname clickable" onClick={this.handler}>
            {item.name}
          </div>
          <div className="rectbox-subtitle">
            {item.organizerName}
          </div>
        </div>
      </div>
    );
  }
}

/**
* AIRowComp component
*/
class AIRowComp extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { item } = this.props;
    const { type } = this.props;
    const url = `${wbConfig.baseUrl}/activity/ActionItemDetails?id=${item.id}`;
    let priorityId = '';
    if (item.priority == 1) {
      priorityId = 'priority_highest';
    } else if (item.priority == 2) {
      priorityId = 'priority_high';
    }
    return (
      <div className="rectbox-row" key={`meet_${type}${item.id}`}>
        <div className="rectbox-col rectbox-col-line rectbox-col-ainame">
          <div className="rectbox-ainame clickable wbActDescDiv" data-model-type="activity" data-url={url}>
            {item.description}
          </div>
        </div>
        <div className="rectbox-col rectbox-col-line rectbox-col-airag">
          <div className="rectbox-airag">
            { priorityId && <ImgIconComp id={priorityId} />}
          </div>
        </div>
      </div>
    );
  }
}

class WbSliderComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      metrics: [],
      currentUserId: null,
      visible: 9,
      currentItem: 0,
      showNext: 0,
      showPrev: 0,
      loading: true,
      itemAddList: 'AddItemList',
    };
    this.removeFromTray = this.removeFromTray.bind(this);
    this.pingMetric = this.pingMetric.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.showNextBtn = this.showNextBtn.bind(this);
    this.showPrevBtn = this.showPrevBtn.bind(this);
    this.animate = this.animate.bind(this);
    this.slide = this.slide.bind(this);
    this.totalMetrics = this.totalMetrics.bind(this);
    this.emptyContent = this.emptyContent.bind(this);
  }

  componentDidMount() {
    const self = this;
    if (cacheRbrMetric.length) {
      self.setState({
        metrics: cacheRbrMetric || [],
        currentUserId: cacheCurrentUserId,
        loading: false,
      });
    } else {
      $.get(`${wbConfig.baseUrl}/rbr/getMyRbrMetrics`)
        .then((response) => {
          self.setState({
            metrics: response.metric || [],
            currentUserId: response.currentUserId,
            loading: false,
          });
        });
    }
  }

  /**
     * remove wathc metric from rbr.
     */
  removeFromTray(item) {
    this.hideMenu();
    const self = this;
    if (typeof item.id !== 'undefined') {
      const modifiedMetrics = self.state.metrics.filter(it => it.id != item.id);
      self.setState({
        metrics: modifiedMetrics,
      });
      $.post(`${wbConfig.baseUrl}/goal/deleteMetricWishList`, { metricId: item.id });
    }
  }

  /**
    * ping metric
    */
  pingMetric(item) {
    this.hideMenu();
    if (typeof item.id !== 'undefined') {
      $.post(`${wbConfig.baseUrl}/goal/sendMetricPingNotification`, { metricId: item.id, metricOwner: item.owner });
    }
  }

  /**
    * hide menu.
    */
  hideMenu() {
    $('#mywobo-metric-wrapper .wspopupmenu-wrapper').hide();
    $('#mywobo-metric-wrapper #wbslider-menu .wbpopumenu').remove();
  }

  /**
    * show next btn if more than visible count.
    */
  showNextBtn() {
    const c = this.state.visible + this.state.currentItem;
    return this.state.metrics.length > c;
  }

  /**
    * show prev btn if have prev data.
    */
  showPrevBtn() {
    return this.state.currentItem >= this.state.visible;
  }

  /**
    *  animate the slider
    */
  animate(dir, count) {
    const itemWidth = $('.wbslider-list .wbslider-item').outerWidth();
    const speed = 600;
    const itemCount = count;
    let marginLeft = -1.0 * itemCount * itemWidth;
    if (dir == 'next') {
      marginLeft += 20;
    }
    $('.wbslider-list').animate({ marginLeft }, speed);
    this.setState({
      currentItem: count,
    });
  }

  /**
    * triggerd slider
    */
  slide(dir) {
    if (dir == 'next') {
      var count = this.state.visible + this.state.currentItem;
      this.animate(dir, count);
    } else if (dir == 'prev') {
      var count = this.state.currentItem - this.state.visible;
      this.animate(dir, count);
    }
  }

  totalMetrics() {
    return this.state.metrics.length;
  }

  emptyContent() {
    const { t } = this.props;

    if (this.totalMetrics()) return;
    return (
      <div className="wbwobo-empty-wrapper">
        <div className="wbwobo-empty-content-wrapper">
          <ImgIconComp id="metrics_empty" width="20" height="20" />
          <span>
Add {t('key results')} by clicking
            <b>'Follow'</b>
            {' '}
from the {t('objective')} detail pop up.
          </span>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;

    const handlers = { removeFromTray: this.removeFromTray, pingMetric: this.pingMetric };
    const showPrev = { display: this.showPrevBtn() ? 'block' : 'none' };
    const showNext = { display: this.showNextBtn() ? 'block' : 'none' };
    const totalMetrics = this.totalMetrics();
    const sliderWidth = Math.ceil(totalMetrics / this.state.visible) * this.state.visible * 131;
    return (
      <div>
        <div className="wbslider recboxshadow">
          {
                this.state.loading && <LoaderComp />
            }
          {!this.state.loading && this.emptyContent()}
          <div className="wbslider-list " ref="wbslider" style={{ maxWidth: `${sliderWidth}px`, display: (totalMetrics ? 'block' : 'none') }}>
            { !this.state.loading && this.state.metrics.map((item, index) => (
              <WatchMetricListItemComp item={item} visible={this.state.visible} index={index} currentItem={this.state.currentItem} currentUserId={this.state.currentUserId} handlers={handlers} showMenu="1" t={t} />
            ))}

            <div style={{ marginTop: '10px' }}>
              <RbrTabButton id="key_result" title={`${t('Key Result')}`} url="goal/getUserMetricList" name="Add a  Key Result" placeholder="Search by metric or owner" itemAddList={this.state.itemAddList} />
            </div>
          </div>
          <button type="button" className="wbslider-btn wbslider-prevbtn" onClick={() => this.slide('prev')} style={showPrev} />
          <button type="button" className="wbslider-btn wbslider-nextbtn" onClick={() => this.slide('next')} style={showNext} />
        </div>

      </div>
    );
  }
}

class ThreeDotKrMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;

    const { item } = this.props;
    const menu = {};
    menu.items = [
      {
			  title: 'Remove from tray',
			  handler: this.props.handlers.removeFromTray,
			  item,
			  pic: 'removefromtray_img',
      },
    ];
    if (this.props.currentUserId && this.props.currentUserId != item.owner) {
		  menu.items.push({
        title: 'Ping',
        handler: this.props.handlers.pingMetric,
        item,
        pic: 'ping_img',
		  });
    }
    return <HamburgMenuComp key={Math.random() * 1000} menu={menu} t={t} />;
  }
}

class WatchMetricListItemComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuEn: false,
    };
    this.mouseover = this.mouseover.bind(this);
    this.mouseout = this.mouseout.bind(this);
  }

  mouseover() {
    this.setState({
      menuEn: true,
    });
  }

  mouseout(e) {
    this.setState({
      menuEn: false,
    });
    // $(this.wbsliderMenu).hide();
    // ReactDOM.unmountComponentAtNode(this.wbsliderMenu);
  }

  render() {
    const { t } = this.props;

    const { item } = this.props;
    let total_target; let metric_format; let metric_color;
    total_target = item.total_target;
    if (item.counting == METRIC_COUNTING_SURVEY_SCALE || item.counting == METRIC_COUNTING_RANGE) {
      total_target = `${item.lower_limit} - ${item.upper_limit}`;
      metric_format = '';
    }
    metric_color = item.metric_progress_color;

    const metric_t = (item.achieve_target.indexOf('-1') >= 0) ? '--' : item.achieve_target;
    const { currentUserId } = this.props;
    const { handlers } = this.props;

    return (
      <div className="wbslider-item clickable" onMouseOver={this.mouseover} onMouseLeave={this.mouseout} id={`metriclist_${item.id}`} key={`metriclist_${item.id}`}>
        <div className="wbslider-item-col wbslider-item-metric-col left " onClick={() => WbEventHandlerMixins.goalMetricPage(item)}>
          <div>
            <span className="wbslider-item-title" style={{ color: metric_color }}>
              {metric_t}
            </span>
            <span style={{ paddingLeft: '5px' }}>
              <img src={`${wbConfig.baseUrl}/images/${item.arrow}`} border="0" width="10" height="10" />
            </span>
            {
						item.counting != METRIC_COUNTING_SURVEY_YES_NO && item.target_display
						&& (
<span style={{ paddingLeft: '5px' }}>
of
  {item.metric_format == '$' ? total_target : total_target}
</span>
						)
					}
          </div>
          <div className="truncate3 wbslider-item-name " title={item.name}>{item.name}</div>
        </div>
        {
				this.state.menuEn
				&& (
<div id="wbslider-menu" wbslider-menuid={item.id} style={{ display: 'block', marginLeft: '185px' }}>
  <ThreeDotKrMenu item={item} currentUserId={this.props.currentUserId} handlers={this.props.handlers} t={t} />
</div>
				)
			}

        <div className="wbslider-item-divider" />
      </div>
    );
  }
}

/**
* fomated date function.
*/
const WbDateFormat = {
  format: 'M d',
  getFormatedDate(date, format) {
    const _format = (typeof format === 'undefined') ? this.format : format;
    if (date) {
      return $.datepicker.formatDate(_format, new Date(date * 1000));
    }
  },
};
const HotboxRow = function (props) {
  const { item } = props;
  const { index } = props;
  const type = item.hotboxType;
  if (type == 'red_goal' || type == 'amber_goal') {
    if (!item.goal) return null;
    return (
      <div className="rectbox-row" key={type + index}>
        <div className="rectbox-col rectbox-icon-col">
          <ImgIconComp id="goal" width="13" height="13" />
        </div>
        <div className="rectbox-col rectbox-gname-col rectbox-col-line">
          <div className="rectbox-title clickable" onClick={() => props.handler.goalPage(item)}>
            {item.goal}
          </div>
          <div className="rectbox-subtitle">
            {item.owner}
          </div>
        </div>
        <div className="rectbox-col rectbox-gicon-col rectbox-col-line">
          <div className="rectbox-redtext" style={{ textAlign: 'right', color: item.color }}>
            {item.prog}
          </div>
        </div>
      </div>
    );
  }
  if (type == 'red_ai') {
    const url = `${wbConfig.baseUrl}/activity/ActionItemDetails?id=${item.id}`;
    return (
      <div className="rectbox-row" key={type + index}>
        <div className="rectbox-col rectbox-icon-col">
          <ImgIconComp id="ai" width="13" height="13" />
        </div>
        <div className="rectbox-col rectbox-gname-col rectbox-col-line">
          <div className="rectbox-title clickable wbActDescDiv" data-model-type="activity" data-url={url}>
            {item.description}
          </div>
        </div>
        <div className="rectbox-col rectbox-gicon-col rectbox-col-line">
          <div className="rectbox-redtext" style={{ textAlign: 'right' }}>
            {WbDateFormat.getFormatedDate(item.due_date)}
          </div>
        </div>
      </div>
    );
  }
  if (type == 'red_1on1_epa') {
    return (
      <div className="rectbox-row rectbox-red1on1-row" key={type + index}>
        <div className="rectbox-col rectbox-icon-col">
          <ImgIconComp id="red_1on1_epa" width="13" height="13" />
        </div>
        <div className="rectbox-col rectbox-gname-col rectbox-col-line">
          <div className="rectbox-title clickable" onClick={() => props.handler.meetingPage(item)}>
            {item.name}
          </div>
        </div>
        <div className="rectbox-col rectbox-epa-col rectbox-col-line">
          <div className="rectbox-subtitle" style={{ textAlign: 'right', padding: '2px 5px 0px 0px' }}>{item.EPA_text}</div>
        </div>
        <div className="rectbox-col rectbox-gicon-col rectbox-col-line">
          <div className="rectbox-redtext">
            {item.EPA}
          </div>
        </div>
      </div>
    );
  }
  if (type == 'red_ws') {
    return (
      <div className="rectbox-row" key={type + index}>
        <div className="rectbox-col rectbox-icon-col">
          <ImgIconComp id="ws_grey" width="13" height="13" />
        </div>
        <div className="rectbox-col rectbox-gname-col rectbox-col-line">
          <div className="rectbox-title clickable" onClick={() => props.handler.workstreamPage(item)}>
            {item.name}
          </div>
          <div className="rectbox-subtitle">
            {item.tname}
          </div>
        </div>
        <div className="rectbox-col rectbox-gicon-col rectbox-col-line">
               &nbsp;
        </div>
      </div>
    );
  }
  if (type == 'red_metrics') {
    return (
      <div className="rectbox-row" key={type + index}>
        <div className="rectbox-col rectbox-icon-col">
          <ImgIconComp id="metric" width="13" height="13" />
        </div>
        <div className="rectbox-col rectbox-gname-col rectbox-col-line">
          <div className="rectbox-title clickable" onClick={() => props.handler.goalMetricPage(item, '', 'rbr')}>
            {item.name}
          </div>
          <div className="rectbox-subtitle">
            {item.owner}
          </div>
        </div>
        <div className="rectbox-col rectbox-gicon-col rectbox-col-line">
          <div style={{ textAlign: 'right' }}>
            <div className="rectbox-redtext" style={{ color: item.progress_color }}>
              {item.achieve_target}
            </div>
            <div className="rectbox-subtitle">
              {item.target ? ` of ${item.target}` : ''}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};


/**
* AIwithCalendarView component
* this is used to display the today/tomorrow ai with CalendarView.
*/
class AIwithCalendarView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ais: [],
      meetings: [],
      loading: true,
    };
    this.getTotalRowCount = this.getTotalRowCount.bind(this);
    this.emptyContent = this.emptyContent.bind(this);
  }

  componentDidMount() {
    let url = '';
    if (this.props.type == 'today') {
      url = 'getTodayAi';
    } else if (this.props.type == 'tomorrow') {
      url = 'getTomorrowAi';
    }
    if (url) {
      const _this = this;
      $.ajax({
        url: `${wbConfig.baseUrl}/rbr/${url}`,
        type: 'get',
      })
        .done((response) => {
          const ais = response.ai || [];
          const meetings = response.meeting || [];
          _this.props.title += ` ${response.date_format}`;
          _this.setState({
            ais,
            meetings,
            loading: false,
          });
        });
    }
  }

  getTotalRowCount() {
    return this.state.ais.length + this.state.meetings.length;
  }

  emptyContent() {
    if (!this.getTotalRowCount()) {
      const message = `You don't have any action items or meetings due ${this.props.type}`;
      return (
        <div className="wbwobo-empty-wrapper">
          <div className="wbwobo-empty-icon-wrapper">
            <ImgIconComp id="today_empty" width="20" height="20" />
          </div>
          <div className="wbwobo-empty-content-wrapper">
            {message}
.
          </div>
        </div>
      );
    }
  }

  render() {
    const { type } = this.props;
    let style = {};
    if (type == 'tomorrow') {
      style = { display: this.getTotalRowCount() ? 'block' : 'none' };
    }
    return (
      <div className={`rectbox-table recboxshadow rectbox-ais-table rectbox-${type}table`} style={style}>
        <div className="rectbox-row rectbox-header">
          <div className="rectbox-htitle" style={{ textTransform: 'uppercase' }}>
            { this.props.title}
          </div>
        </div>
        { this.state.loading && <LoaderComp />}
        { !this.state.loading && this.emptyContent() }
        { !this.state.loading && this.state.meetings.map((item, index) => (
          <MeetRowComp item={item} key={`${type}meet${index}`} type={type} />
        ))
            }
        { !this.state.loading && this.state.ais.map((item, index) => (
          <AIRowComp item={item} key={`${type}ai${index}`} type={type} />
        ))
            }
      </div>
    );
  }
}
AIwithCalendarView.defaultProps = {
  title: '',
  type: '',
};

/**
* checkbox component
*/
class CheckBoxComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.checked || false,
    };
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  componentDidMount() {
    if (this.props.name == 'action_items') {
      let defaultDate = $('input.wbmodal-datefields').attr('data-value');
      this.datepicker = $('input.wbmodal-datefields');
      const _this = this;
      $(this.datepicker).datepicker({
        showAnim: 'slide',
        dateFormat: 'M d,yy',
        setDate: defaultDate,
        onChangeMonthYear(year, month, inst) {
          const buttonPane = $(inst.input).datepicker('widget');
          $(buttonPane).find('button.newStyleForDatePicker').remove();
          setTimeout(() => {
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(inst.input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        beforeShow(input) {
          $('#ui-datepicker-div').addClass('dataTimePicker wbmodal-datepicker');
          setTimeout(() => {
            const buttonPane = $(input).datepicker('widget');
            const btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
            btn
              .off('click')
              .on('click', () => {
                $.datepicker._clearDate(input);
              });
            if ($('.wbmodal-datepicker .newStyleForDatePicker').length == 0) {
              btn.appendTo(buttonPane);
            }
          }, 1);
        },
        onSelect(date) {
          const data = {};
          data.date_range = { start: date };
          _this.props.handler(data);
        },
      });
      if (defaultDate == 'undefined' || defaultDate == 0) {
        defaultDate = 0;
      } else {
        defaultDate = $.datepicker.formatDate('M d, yy', new Date(defaultDate * 1000));
        $(this.datepicker).datepicker('setDate', defaultDate);
      }
    }
  }

  componentWillUnmount() {
  }

  toggleCheckbox(e) {
    this.setState({
      isChecked: e.target.checked,
    });
    if (this.props.handler !== 'undefined') {
      const data = {};
      const eventName = e.target.name;
      const checked = (e.target.checked) ? 1 : 0;
      data[eventName] = checked;
      if (eventName == 'action_items') {
        const defaultDate = $('input.wbmodal-datefields').attr('data-value');
        if (checked) {
          $('input.wbmodal-datefields').prop('disabled', false).val('');
        } else {
          $('input.wbmodal-datefields').prop('disabled', 'disabled').val('');
        }
        data.date_range = { start: '' };
      }
      if (eventName == 'comment') {
        if (checked) {
          $("input[value='okrs']").prop('checked', true);
        } else {
          // $("input[value='okrs']").prop('checked', false);
        }
      }
      if (eventName == 'okrs') {
        if (!checked) {
          $("input[value='comment']").prop('checked', false);
        }
      }
      this.props.handler(data);
    }
  }

  render() {
    const { props } = this;
    const uniqueId = WbUniqueIdMixin.uniqueId('wbchk');
    const imageIcon = props.imageId ? <ImgIconComp id={props.imageId} /> : '';
    return (
      <div className="chkbox wbcheckboxcomp">
        <input type="checkbox" className="css-checkbox" onChange={this.toggleCheckbox} checked={this.state.isChecked} value={props.value} name={props.name} id={uniqueId} />
        <label className="css-label modalParaText" htmlFor={uniqueId}>
          {' '}
          {imageIcon}
          {' '}
          {props.title}
        </label>
      </div>
    );
  }
}

/**
* Rbr top menu component
*/
class MyRbrTopMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      personalizeForm: {},
      printForm: {},
    };
    this.viewPersonalize = this.viewPersonalize.bind(this);
    this.closeModalBox = this.closeModalBox.bind(this);
    this.modifiedData = this.modifiedData.bind(this);
    this.printData = this.printData.bind(this);
    this.saveRbrData = this.saveRbrData.bind(this);
    this.viewPopup = this.viewPopup.bind(this);
    this.viewPrint = this.viewPrint.bind(this);
    this.viewPrintPopup = this.viewPrintPopup.bind(this);
    this.printRbrData = this.printRbrData.bind(this);
    this.shareRbr = this.shareRbr.bind(this);
    this.closeModalBox = this.closeModalBox.bind(this);
    this.shareRbrPopup = this.shareRbrPopup.bind(this);
  }

  /**
    * view personalizeForm popup
    */
  viewPersonalize(item) {
    const _this = this;
    $.get(`${wbConfig.baseUrl}/rbr/viewPersonalize`)
      .then((response) => {
        woboAddRbrPersonalizePopup.dialogOpen().html('');
        ReactDOM.render(_this.viewPopup(response.rbr), document.getElementById('wobo-add-rbr-personalize-popup'));
      });
  }

  /**
     * close personalizeForm popup
     */
  closeModalBox() {
    $('input.wbmodal-datefields').datepicker('destroy');
    const isOpen = $(woboAddRbrPrintPopup).dialog('isOpen');
    if (isOpen == 1) {
      $(woboAddRbrPrintPopup).dialog('close');
    } else {
      $(woboAddRbrPersonalizePopup).dialog('close');
    }
  }

  /**
     * modified personalizeForm data.
     */
  modifiedData(item) {
    const personalizeForm = $.extend(this.state.personalizeForm, item);
    this.setState({ personalizeForm });
  }

  printData(item) {
    let { printForm } = this.state;
    printForm = Object.assign(printForm, item);
    if (item.okrs == 0 && printForm.comment == 1) {
      printForm.comment = 0;
    }
    if (printForm.comment == 1) {
      printForm.okrs = 1;
    }
    this.setState({ printForm });
  }

  /**
     * save rbr data.
     */
  saveRbrData(data) {
    const _this = this;
    const formData = { hotbox: _this.state.personalizeForm };
    showLoader($('.contentTd2 #content'));
    $.post(`${wbConfig.baseUrl}/rbr/savePersonalize`, formData, (response) => {
      removeLoader();
      _this.closeModalBox();
      cacheRbrHotBox = [];
      isViewFullListHotbox = false;
      woboPageLoadComponent(['mywoborbr_hotbox_wrapper']);
    });
  }

  /**
     * view personalize rbr popup
     */
  viewPopup(data) {
    const response = (typeof data.preferences.personalize.hotbox !== 'undefined') ? data.preferences.personalize.hotbox : {};
    this.setState({ personalizeForm: response });
    const enableModules = wbConfig.enableModules || {};
    const goalModule = (typeof enableModules.goal !== 'undefined' && enableModules.goal != 0);
    const executeModule = (typeof enableModules.execute !== 'undefined' && enableModules.execute != 0);
    const meetingModule = (typeof enableModules.meeting !== 'undefined' && enableModules.meeting != 0);

    return (
      <div className="wbmodal wbmodal-personalize">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>Personalize My RBR</b>
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={this.closeModalBox}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content">
          <div>
            <span>Show on </span>
            <span className="hotboxtext">HOT BOX:</span>
          </div>
          { goalModule
                    && (
                    <div>
                      <div>
                        <CheckBoxComp title="Red Goals" handler={this.modifiedData} imageId="red" name="red_goals" checked={response.red_goals == 1} value={response.red_goals} />
                      </div>
                      <div>
                        <CheckBoxComp title="Amber Goals" handler={this.modifiedData} imageId="amber" name="amber_goals" checked={response.amber_goals == 1} value={response.amber_goals} />
                      </div>
                      <div>
                        <CheckBoxComp title="Metrics" handler={this.modifiedData} checked={response.metrics == 1} name="metrics" value={response.metrics} />
                      </div>
                    </div>
                    )
                }
          { executeModule
                    && (
                    <div>
                      <div>
                        <CheckBoxComp title="Workstreams" handler={this.modifiedData} checked={response.workstreams == 1} name="workstreams" value={response.workstreams} />
                      </div>
                      <div>
                        <CheckBoxComp title="Action items" handler={this.modifiedData} checked={response.action_items == 1} name="action_items" value={response.action_items} />
                        <div className="wbmodal-personalize-datefields">
                          <span>From</span>
                          <input type="text" className="wbmodal-datefields" data-value={response.date_range.start} disabled={response.action_items != 1} value="" />
                        </div>
                      </div>
                    </div>
                    )
                    }
          { meetingModule
                    && (
                    <div>
                      <CheckBoxComp title="Direct Reports in the red" handler={this.modifiedData} name="direct_reports_red" checked={response.direct_reports_red == 1} value={response.direct_reports_red} />
                    </div>
                    )
                    }
          <div className="gbl-butn-wraper">
            <div className="gbl-btn" onClick={this.saveRbrData}>Save</div>
          </div>
        </div>
      </div>
    );
  }

  /**
     * view viewPrintForm popup
     */
  viewPrint(item) {
    const _this = this;
    woboAddRbrPrintPopup.dialogOpen().html('');
    ReactDOM.render(_this.viewPrintPopup(), document.getElementById('wobo-add-rbr-viewPrint-popup'));
  }

  /**
     * view Print rbr popup
     */
  viewPrintPopup(data) {
    const { t } = this.props;

    const enableModules = wbConfig.enableModules || {};
    const goalModule = (typeof enableModules.goal !== 'undefined' && enableModules.goal != 0);
    const executeModule = (typeof enableModules.execute !== 'undefined' && enableModules.execute != 0);
    const meetingModule = (typeof enableModules.meeting !== 'undefined' && enableModules.meeting != 0);
    return (
      <div className="wbmodal wbmodal-print">
        <div id="printerror" style={{ display: 'none' }}>you want to include in your report </div>
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>Publish or Print</b>
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={this.closeModalBox}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content" style={{ padding: '10px 30px' }}>
          <div>
            <span>What do you want to include </span>
          </div>

          <div>
            { goalModule
                        && (
                        <div className="inputcontainer">
                          <CheckBoxComp title={`${t('Objectives')}`} handler={this.printData} name="okrs" value="okrs" />
                        </div>
                        )

                    }
            {' '}
            <div className="inputcontainer">
              <CheckBoxComp title={`Last comment on ${t('objective')} (narrative) `} handler={this.printData} name="comment" value="comment" />
            </div>
            { executeModule
                        && (
                        <div className="inputcontainer">
                          <CheckBoxComp title="Workstreams" handler={this.printData} name="works" value="works" />
                        </div>
                        )
                    }
            <div className="inputcontainer">
              <CheckBoxComp title="Hot Box" handler={this.printData} name="hotb" value="hotb" />
            </div>
            { goalModule
                        && (
                        <div className="inputcontainer">
                          <CheckBoxComp title="Results ticker top of page" handler={this.printData} name="metrc" value="metrc " />
                        </div>
                        )
                    }

            <div className="inputcontainer">
              <CheckBoxComp title="Today" handler={this.printData} name="tody" value="tody" />
            </div>
            { (meetingModule || executeModule)
                    && (
                    <div className="inputcontainer">
                      <CheckBoxComp title="Tomorrow" handler={this.printData} name="tomorow" value="tomorow" />
                    </div>
                    )
                    }

          </div>

          <div className="gbl-butn-wraper" style={{ float: 'right', width: '85px' }}>
            <div className="gbl-btn" onClick={this.printRbrData}>Preview</div>
          </div>
        </div>
      </div>
    );
  }

  /**
     * print rbr data.
     */
  printRbrData(data) {
    const _this = this;
    const formData = _this.state.printForm;
    if ($.isEmptyObject(formData) || (!formData.comment && !formData.hotb && !formData.metrc
        && !formData.okrs && !formData.tody && !formData.tomorow && !formData.works)) {
    } else {
      showLoader($('.contentTd2 #content'));
      const params = {};
      const buildParams = $.param(formData);
      _this.closeModalBox();
      ajaxPageLoad(`${wbConfig.baseUrl}/rbr/publishRbr?${buildParams}`, 'get', formData, undefined, 'menu-wb-mywoborbr');
    }
  }

  // share rbr
  shareRbr(item) {
    const _this = this;
    shareRbrDatapopUp.dialogOpen().html('');
    ReactDOM.render(_this.shareRbrPopup(), document.getElementById('shareRbrData'));
  }

  closeModalBox() {
    $(shareRbrDatapopUp).dialog('close');
  }

  shareRbrPopup(data) {
    const { t } = this.props;

    const placeholerText = `Please view or edit ${t('objectives')}, ${$('key results')}, workstreams and action items to this RBR.`;
    const placeholderText = 'search by team or person';
    return (
      <div className="wbmodal wbmodal-share">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left shareRbrtitle">
            <b>Share your RBR</b>
          </div>
          <div className="wbmodal-hcancel right clickable" onClick={this.closeModalBox}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content" style={{ padding: '10px 30px' }}>
          <div className="shareRbrtitle">
            <span>Custom message: </span>
          </div>
          <div className="addshare-text-wrapper">
            <input type="text" name="s" placeholder={placeholerText} />
          </div>
          <div className="shareOrg">
            <span className="checkBoxStyle">
              <input type="checkbox" name="checkAll" id="checkAll" checked="checked" />
              <label htmlFor="checkAll" className="checkboxLabel" />
            </span>
            <span>Share with organization</span>
          </div>
          <div className="addshare-text-search">
            <input type="text" name="s" placeholder={placeholderText} />
          </div>
          <div className="sharedMembers">
            <div className="sharedImage">
              <ImgIconComp id="userImage" width="35" height="35" />
            </div>
            <div className="sharedName">
                            Samuel Robinson
            </div>
            <div className="gbl-butn-wraper sharedView" style={{ width: '75px' }}>
              <div className="gbl-btn">view</div>
            </div>
            <div className="gbl-butn-wraper sharedEdit" style={{ width: '75px' }}>
              <div className="gbl-btn">edit</div>
            </div>
            <div className="sharedDelete">
              <ImgIconComp id="close" width="12" height="12" />
            </div>
          </div>

          <div className="gbl-butn-wraper" style={{ float: 'right', width: '85px', paddingTop: '10px' }}>
            <div className="gbl-btn">Share</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;

    const menu = {
      mainmenu: 1,
      items: [{
        title: 'Personalize',
        handler: this.viewPersonalize,
        class: 'personalize',
        pic: 'personalize_img',

      },
      {
        title: 'Share',
        handler: this.shareRbr,
        class: 'shareRbr',
        pic: 'share_rbr',

      },
      {
        title: 'Publish',
        handler: this.viewPrint,
        class: 'print',
        pic: 'publish_img_board',
      },
      {
        title: 'Leave RBR',
        handler: this.viewPrint,
        class: 'leave_rbr',
        pic: 'logout_pic',
      }, {
        title: 'Delete RBR',
        handler: this.viewPrint,
        class: 'leave_rbr',
        pic: 'delete_img',
      }],
    };
    return <HamburgMenuComp key={Math.random() * 1000} menu={menu} t={t} />;
  }
}

const RbrPublishViewComp = function (props) {
  const { t } = useTranslation();
  const { items } = props;
  const handlers = { removeFromTray: 0 };
  const { type } = props;
  if (type === 'undefined' || type == '') {
    return null;
  }

  let meetings = [];
  let ais = [];

  if (type == 'hotbox') {
    if (type == 'today' || type == 'tomorrow') {
      meetings = items.meeting || [];
      ais = items.ais || [];
    }
  }

  return (
    <div>
      { type == 'goal'
            && items.map((item, index) => (
              <GoalListCompRow goal={item} t={t} />
            ))
          }
      { type == 'ws'
            && items.map((item, index) => (
              <WsListsRowComp ws={item} showMenu="1" handlers={handlers} t={t} />
            ))
          }

      { (type == 'today' || type == 'tomorrow') && (
        meetings.length && meetings.map((item, index) => (
          <MeetRowComp item={item} key={`${type}meet${index}`} type={type} />
        ))
      )
          }

      { (type == 'today' || type == 'tomorrow') && (
        ais.length && ais.map((item, index) => (
          <AIRowComp item={item} key={`${type}ai${index}`} type={type} />
        ))
      )
          }

      { type == 'hotbox'
            && items.hotbox.map((item, index) => (
              <HotboxRow item={item} index={index} />
            ))
          }
    </div>
  );
};


const publishRbrPageComp = function () {
  ReactDOM.render(<RbrPublishViewComp type="goal" items={pub_rbrGoals} />, document.getElementById('rbr-publish-okrs'));
  ReactDOM.render(<RbrPublishViewComp type="ws" items={pub_rbrWs} />, document.getElementById('rbr-publish-ws'));
  ReactDOM.render(<RbrPublishViewComp type="hotbox" items={pub_rbrHotbox} />, document.getElementById('rbr-publish-hotboax'));
  ReactDOM.render(<RbrPublishViewComp type="metric" items={pub_rbrMetric} />, document.getElementById('rbr-publish-metric'));
  ReactDOM.render(<RbrPublishViewComp type="today" items={pub_rbrToday} />, document.getElementById('rbr-publish-today'));
  ReactDOM.render(<RbrPublishViewComp type="tomorrow" items={pub_rbrtomorrow} />, document.getElementById('rbr-publish-tomorrow'));
};

const renderReactListItems = function (data, mountId) {
  ReactDOM.render(<ListItemComp props={data} />, document.getElementById(mountId));
};

const ListItemComp = function (props) {
  const _props = props.props;
  const items = _props.items || [];
  const title = _props.title || '';
  if (!items.length) {
    return (
      <div className="listitemcomp-wrapper">
        {title && <div className="listitemcomp-title">{title}</div>}
        <div className="listitemcomp-items">No Reportees.</div>
      </div>
    );
  }
  return (
    <div className="listitemcomp-wrapper">
      {title && <div className="listitemcomp-title">{title}</div>}
      { items.length
              && (
              <div className="listitemcomp-items">
                {
                items.map((item, index) => (
                  <div className="listitemcomp-item clickable" onClick={() => WbEventHandlerMixins.teamMemberPage(item)} key={index}>
                    {item.fullName}
                  </div>
                ))
              }
              </div>
              )
          }
    </div>
  );
};
